import { render } from "./ManageStrategy.vue?vue&type=template&id=83e18e84&scoped=true"
import script from "./ManageStrategy.vue?vue&type=script&lang=js"
export * from "./ManageStrategy.vue?vue&type=script&lang=js"

import "./ManageStrategy.vue?vue&type=style&index=0&id=83e18e84&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83e18e84"]])

export default __exports__